export default function createApi({ authorizedApi }) {
  const getFreshdeskUrl = () => authorizedApi().post(`/sso_freshdesk`);

  return { getFreshdeskUrl };
}
